import { Buffer } from 'buffer'; //Don't remove - This import is needed for mobile or biller logos go missing

import { all, call, debounce, put, takeEvery } from 'redux-saga/effects';

import { getEnvironmentConfig, getLogger, httpClientInterface } from '../../utils/core';
import { resourceSagaUtils, resourceStoreTypes } from '../core';

import * as actions from './billersActions';
import { getLastSyncDate } from './billersSelectors';
import {
  transformResponseToBiller,
  transformResponseToBillers,
  transformSearchResponseToBillers,
} from './billersTransformers';

const log = getLogger('flux/billers - sagas');

export function* getBiller(action) {
  log.log('getBiller called...');

  const { payload: billerId } = action;
  if (!billerId) {
    log.log('Invalid getBiller (no Id)');
    yield put(actions.getBillerFailure('No Id, invalid get'));
  }

  const resourceBaseUrl = `/billpresentment/billers?query=%28providerBillerID%3D%3D%22${billerId}%22%29`;
  yield call(
    resourceSagaUtils.qcsSyncGetResources,
    resourceStoreTypes.mkQcsSyncResourceConfig({
      resourceName: 'billers',
      resourceBaseUrl,
      transformResponseToResources: transformResponseToBiller,
      successAction: actions.getBillerSuccess,
      failureAction: actions.getBillerFailure,
    }),
  );
}

export function* searchForBillers({ payload: searchString, meta }) {
  log.log('searchForBillers called...', searchString);

  const escapedSearchString = encodeURIComponent(searchString);

  const resourceBaseUrl = `/billpresentment/billers/search?limit=30&query=(searchTerm%3D%3D%22${escapedSearchString}%22)`;
  const billersSearchAction = { meta };

  yield call(
    resourceSagaUtils.qcsSyncGetResources,
    resourceStoreTypes.mkQcsSyncResourceConfig({
      resourceName: 'billersSearch',
      resourceBaseUrl,
      transformResponseToResources: transformSearchResponseToBillers,
      successAction: actions.searchForBillersSuccess,
      failureAction: actions.searchForBillersFailure,
    }),
    billersSearchAction,
  );
}

export function* getBillerLogo({ payload: billerId }) {
  log.log('getBillerLogo called...');

  const requestUrl = `${
    getEnvironmentConfig().services_url
  }/billpresentment/billers/logo?query=%28providerBillerID%3D%3D%22${billerId}%22%29`;

  try {
    const response = yield call(httpClientInterface.send, 'GET', requestUrl, undefined, undefined, undefined, {
      responseType: 'arraybuffer',
    });
    // eslint-disable-next-line no-undef
    const buffer = Buffer.from(response.data, 'binary').toString('base64');
    yield put(actions.getBillerLogoResponse({ id: billerId, logo: buffer }));
  } catch (error) {
    log.log('Error retrieving billerLogo', error);
    yield put(actions.getBillerLogoError(error));
  }
}

// =============================================================================
// Watchers
// =============================================================================

function* getBillerActionWatcher() {
  yield takeEvery(actions.getBiller, getBiller);
}

function* getPopularBillersActionWatcher() {
  yield takeEvery(
    actions.getPopularBillersAction,
    resourceSagaUtils.qcsSyncGetResources,
    resourceStoreTypes.mkQcsSyncResourceConfig({
      resourceName: 'popularBillers',
      resourceBaseUrl: '/billpresentment/billers/popular',
      axiosConfig: { params: { limit: 15 } },
      getLastSyncDate,
      transformResponseToResources: transformResponseToBillers,
      transformResourceToRequestData: null,
      successAction: actions.getPopularBillersSuccess,
      failureAction: actions.getPopularBillersFailure,
    }),
  );
}

function* getPopularBillersSuccessActionWatcher() {
  yield takeEvery(actions.getPopularBillersSuccess, function* getPopularBillerLogo({ payload }) {
    const popularBillers = payload.resources;
    yield all(popularBillers.map((popularBiller) => put(actions.getBillerLogo(popularBiller.id))));
  });
}

function* searchForBillersActionWatcher() {
  // debouncing to reduce chance of race conditions applying between queries
  // (old searches sometimes would clobber newer searches because they took longer)
  yield debounce(400, actions.searchForBillers, searchForBillers);
}
function* getBillerLogoActionWatcher() {
  yield takeEvery(actions.getBillerLogo, getBillerLogo);
}

export default [
  getBillerActionWatcher,
  getPopularBillersActionWatcher,
  getPopularBillersSuccessActionWatcher,
  searchForBillersActionWatcher,
  getBillerLogoActionWatcher,
];
